<template>
  <div class="fixed flex items-center justify-center top-0 left-0 bottom-0 right-0 z-30">
    <div
      class="fixed top-0 bottom-0 left-0 right-0 bg-transparent z-40"
      @click="$emit('close')"
    />
    <div class="rounded bg-white p-4 shadow-depth-300 max-h-screen overflow-hidden z-50 shadow-lg">
      <div
        v-if="title || this.$slots.header || isClosable"
        class="mb-3"
      >
        <font-awesome-icon
          v-if="isClosable"
          :icon="['fal', 'times']"
          class="cursor-pointer float-right ml-4 mb-4"
          @click="$emit('close')"
        />
        <slot name="header">
          <span class="text-base font-bold capitalize">{{ title }}</span>
        </slot>
      </div>
      <div>
        <slot name="default">
          <span class="text-default">
            {{ text }}
          </span>
        </slot>
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
library.add(faTimes)

export default {
  name: 'Popup',
  components: {
    FontAwesomeIcon
  },
  props: {
    title: { type: String, default: null },
    text: { type: String, default: null },
    isClosable: { type: Boolean, default: false }
  }
}
</script>
